import { WorkflowButtons, WorkflowButtonsStore } from '@servicetitan/financing-workflow-shared';
import { PropsWithChildren } from 'react';
import {
    CancelApplicationButton,
    DoneButton,
    CloseWithoutConfirmingButton,
    ViewOfferDetailsButton,
} from '../common/buttons';

const workflowButtons: WorkflowButtons = {
    DoneButton,
    CancelApplicationButton,
    CloseWithoutConfirmingButton,
    ViewOfferDetailsButton,
};

export const WorkflowButtonsProvider = ({ children }: PropsWithChildren) => {
    return (
        <WorkflowButtonsStore.Provider initialState={workflowButtons}>
            {children}
        </WorkflowButtonsStore.Provider>
    );
};
